import { render, staticRenderFns } from "./ReservationInfoBlock.vue?vue&type=template&id=09b33b53&scoped=true&"
import script from "./ReservationInfoBlock.vue?vue&type=script&lang=js&"
export * from "./ReservationInfoBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b33b53",
  null
  
)

export default component.exports